import { Navigate, useParams } from "react-router-dom";

const SlotChangeProposalsPage = () => {
  const { schoolId, trainingId } = useParams();

  return (
    <Navigate
      to={`/school/${schoolId}/admin/slot-change-requests/${trainingId}/proposals`}
      replace={true}
    />
  );
};

export default SlotChangeProposalsPage;
